import FGField from "./FGField";
import { useRef, useState, useEffect } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import PopupWLFieldEditor, {
  TPopupWLFieldEditorRef,
} from "../popup/PopupWLFieldEditor";
import ModulePopup from "../../modules/popup/popup";

export type WLField = {
  name: string;
  description: string;
  max_word: string | number;
  _id: string | null | undefined;
};

type TWLFieldsEditorProps = {
  value: Array<WLField>;
  disabled?: boolean;
  archived?: boolean;
  cohortCount?: number;
  showRemoveFieldConfirm?: boolean;
  onChange?: (value: Array<WLField>) => void;
};

export default function WLFieldsEditor(props: TWLFieldsEditorProps) {
  const [value, setValue] = useState<Array<WLField>>([]);
  const [index, setIndex] = useState<number>(-1);

  const refPopupWLFieldEditor = useRef<TPopupWLFieldEditorRef>();

  useEffect(() => setValue(props.value), [props.value]);

  const add = () => refPopupWLFieldEditor.current.show();

  const edit = (index: number) => {
    setIndex(index);
    refPopupWLFieldEditor.current.setEdit(true);
    refPopupWLFieldEditor.current.show();
  };

  const hide = () => index > -1 && setIndex(-1);

  const save = (field: WLField) => {
    let newValue = [...value];
    if (index > -1) {
      newValue[index] = field;
    } else {
      newValue.push(field);
    }
    props.onChange && props.onChange(newValue);
  };

  const remove = (index: number) => {
    let newValue = [...value];
    newValue.splice(index, 1);
    props.onChange && props.onChange(newValue);
  };

  return (
    <>
      <div className="row wl-fields-editor">
        <div className="col-lg-6">
          <FGField name="fields" label="Sections" required={!props.disabled}>
            {value.length ? (
              <table className="w-100">
                <tbody>
                  {value.map((item, i) => (
                    <tr key={`wl-field-${i}`}>
                      <td>
                        <div className="d-flex align-items-center">
                          <b className="flex-grow-1">{item.name}</b>
                            <div className="d-flex flex-row-reserve align-items-center gap-2">
                              {!props.archived && <MdModeEditOutline
                                size={24}
                                title="Edit"
                                className="cursor-pointer icon-action-default"
                                onClick={() => edit(i)}
                              />}

                              {!props.disabled && <MdDelete
                                size={24}
                                title="Delete"
                                className="cursor-pointer icon-action-default"
                                onClick={() =>
                                  ModulePopup.showAlertConfirm({
                                    onYes: () => remove(i),
                                    title: "Delete Confirmation",
                                    description: (
                                      <>
                                        <p>
                                          Are you sure you want to delete this
                                          section ({item.name})?
                                        </p>
                                      </>
                                    ),
                                  })
                                }
                              />}
                            </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ marginBottom: 10, fontStyle: "italic" }}>
                Currently empty. Please add one
              </div>
            )}
            {!props.disabled && (
              <div>
                <button
                  type="button"
                  className="btn btn-sm btn-primary btn-add"
                  onClick={add}
                >
                  Add New Section
                </button>
              </div>
            )}
          </FGField>
        </div>
      </div>

      <PopupWLFieldEditor
        ref={refPopupWLFieldEditor}
        value={value[index] ?? null}
        onHide={hide}
        onSave={save}
      />
    </>
  );
}
